export let logoutTimer: NodeJS.Timeout | null = null;

export const setLogoutTimer = (callback: () => void, timeInSeconds: number) => {
    if (logoutTimer) {
        clearTimeout(logoutTimer);
    }

    logoutTimer = setTimeout(callback, timeInSeconds * 1000);
};

export const clearLogoutTimer = () => {
    if (logoutTimer) {
        clearTimeout(logoutTimer);
        logoutTimer = null;
    }
};
